// extracted by mini-css-extract-plugin
export default {"cardContainer":"norway_cardContainer__eYLO0","chartCard":"norway_chartCard__XKwju","tablesCard":"norway_tablesCard__Lvx81"};